<script lang="ts">
  import type { VideoItem } from '$lib/types';

  interface Props extends VideoItem {
    current: boolean;
  }

  const { videoId, current }: Props = $props();
  let iframeElement: HTMLIFrameElement | undefined = $state(); // Reference to the iframe

  // Monitor active state to pause video when user navigates away
  $effect(() => {
    if (!current && iframeElement?.contentWindow) {
      iframeElement.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
        '*'
      );
    }
  });
</script>

<div class="video-container">
  <iframe
    bind:this={iframeElement}
    title="Youtube Video Player"
    src="https://www.youtube.com/embed/{videoId}?enablejsapi=1"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;"
    frameborder="0"
  ></iframe>
</div>

<style>
  .video-container {
    width: 100%;
    height: 100%;
  }

  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid var(--light-purple);
    border-radius: 15px;
    background-color: #000;
  }
</style>
